import { magicLinkService } from '../_services/magicLink.service';

function sendToClient(params) {
    return function (dispatch) {
        return new Promise(function (resolve, reject) {
            magicLinkService.sendToClient(params)
                .then(response => resolve(response))
                .catch(err => reject(err));
        });
    };
}

function consumeToken(token) {
    return function (dispatch) {
        return new Promise(function (resolve, reject) {
            magicLinkService.consumeToken(token)
                .then(response => resolve(response))
                .catch(err => reject(err));
        });
    };
}

export const magicLinkActions = {
    sendToClient,
    consumeToken
};
